import React, { useState, useEffect } from 'react';
import css from './DeviceSelection.module.scss';
import { useDispatch } from 'react-redux';
import { actions } from '../store';
import { useSelector } from '../hook-utils';
import { selectSecondaryRingerDevice } from '../store/reducers/localSettings';

export type Device = {
  id: string
  displayName: string
}

export default function DeviceSelection() {
  const dispatch = useDispatch()
  const [devices, setDevices] = useState<Device[]>([])
  const [selectedDevice, setSelectedDevice] = useState<string>()
  const secondaryRingerDevice = useSelector(selectSecondaryRingerDevice)

  useEffect(() => {
    try {
      navigator.mediaDevices.enumerateDevices()
        .then(devices => {

          const outputDevices : Device[] = devices.filter(info => info.kind === 'audiooutput').map(info => ({ id: info.deviceId, displayName: info.label }))
          const deviceList = getUniqueArray([{ id: '', displayName: 'No Secondary Ringer' }, ...outputDevices])
          setDevices(deviceList)
          let selectedDevice = deviceList.find(device => device.id === secondaryRingerDevice.deviceId)
          if (selectedDevice === undefined) {
            // no exact device id found. We'll try the name instead.
            selectedDevice = deviceList.find(device => device.displayName === secondaryRingerDevice.displayName)
          }

          if (selectedDevice === undefined) {
            setSelectedDevice(undefined)
          } else {
            setSelectedDevice(selectedDevice.id)
            dispatch(actions.setSecondaryRingerDevice(selectedDevice.id, selectedDevice.displayName))
          }
        })
        .catch(reason => {
          console.error('failed to enumerate devices', reason)
        })
    } catch (x) {
      console.error('failed to get devices', x)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div className={css.deviceSelectionContainer}>
    <h4>Secondary Ringer Device</h4>
    <select id='secondaryRingerAudioDeviceId' value={selectedDevice}
      onChange={e => {
        let selectedDevice = devices.find(device => device.id === e.currentTarget.value)
        if (selectedDevice === undefined) return
        setSelectedDevice(selectedDevice.id)
        dispatch(actions.setSecondaryRingerDevice(selectedDevice.id, selectedDevice.displayName))
      }}>
      {devices.map(device => (<option key={ device.id} value={device.id}>{device.displayName}</option>))}
    </select>
  </div>
}


function getUniqueArray(array: Device[]) : Device[]{
  let uniqueArray = [];
  if (array.length > 0) {
    uniqueArray[0] = array[0];
  }
  for (let i = 0; i < array.length; i++) {
    let isExist = false;
    for (let j = 0; j < uniqueArray.length; j++) {
      if (array[i].id === uniqueArray[j].id) {
        isExist = true;
        break;
      }
      else {
        isExist = false;
      }
    }
    if (isExist === false) {
      uniqueArray[uniqueArray.length] = array[i];
    }
  }
  return uniqueArray;
}
